export { default } from './GoodsTransferProgressInfo'
